import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

function Projects() {
  const projects = [
    {
      imgPath:
        "https://images.unsplash.com/photo-1593642634443-44adaa06623a?auto=format&fit=crop&w=900&q=80",
      title: "Enterprise Data Lakehouse",
      description:
        "Built a cloud-native Data Lakehouse using S3, Glue, and Athena with Delta Lake. Automated ETL pipelines using Airflow and dbt, increasing analytics efficiency by 40%.",
    },
    {
      imgPath:
        "https://images.unsplash.com/photo-1547190027-9156686aa2f0?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MjB8fGthZmthJTIwc3RyZWFtaW5nJTIwaW4lMjBkYXRhJTIwZW5naW5lZXJpbmd8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=600",
      title: "Real-time Kafka Streaming Platform",
      description:
        "Developed a scalable real-time data streaming system using Kafka and Spark Streaming, integrating observability with Prometheus and Grafana.",
    },
    {
      imgPath:
        "https://images.unsplash.com/photo-1551302175-952301267d19?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8ZGF0YSUyMG9yY2hlc3RyYXRpb258ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=600",
      title: "Data Orchestration with Airflow",
      description:
        "Implemented modular DAGs in Apache Airflow for automating ETL workflows. Deployed using Terraform and integrated CI/CD pipelines via GitHub Actions.",
    },
    {
      imgPath:
        "https://images.unsplash.com/photo-1556761175-4b46a572b786?auto=format&fit=crop&w=900&q=80",
      title: "dbt Analytics Warehouse",
      description:
        "Developed dbt models on Snowflake for consistent and reliable data transformations. Added tests and documentation for visibility and governance.",
    },
    {
      imgPath:
        "https://images.unsplash.com/photo-1591696205602-2f950c417cb9?auto=format&fit=crop&w=900&q=80",
      title: "MLOps with MLflow and SageMaker",
      description:
        "Built automated ML pipelines with MLflow and SageMaker, enabling model versioning, deployment, and continuous monitoring for production-grade ML systems.",
    },
    {
      imgPath:
        "https://images.unsplash.com/photo-1686061592689-312bbfb5c055?ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MTB8fGRhc2hib2FyZHN8ZW58MHx8MHx8fDA%3D&auto=format&fit=crop&q=60&w=600",
      title: "Observability Dashboard",
      description:
        "Created real-time observability dashboards using Grafana and CloudWatch to visualize data pipeline health, latency, and throughput metrics.",
    },
  ];

  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading text-center mb-4">
          <strong className="purple">Data Engineering Portfolio</strong>
        </h1>
        <p
          style={{
            color: "white",
            textAlign: "center",
            marginBottom: "50px",
            fontSize: "1.1rem",
          }}
        >
          Showcasing projects across <strong>data architecture</strong>,{" "}
          <strong>streaming systems</strong>, and{" "}
          <strong>cloud automation</strong> — built for scalability and insight.
        </p>

        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          {projects.map((project, idx) => (
            <Col key={idx} md={4} className="project-card">
              <ProjectCard
                imgPath={project.imgPath}
                isBlog={false}
                title={project.title}
                description={project.description}
              />
            </Col>
          ))}
        </Row>

        <h2
          className="text-center mt-5"
          style={{ color: "#b19cd9", fontWeight: "600" }}
        >
          Building <span className="purple">scalable</span> and{" "}
          <span className="purple">data-driven</span> cloud platforms.
        </h2>
      </Container>
    </Container>
  );
}

export default Projects;
